<template>
  <div class="forgot-password">
    <TitleBar :text="$t('ForgotPassword.topic')" :enableIconButton="false" @clickCloseButton="clickCloseButton" />
    <div class="body">
      <form v-if="infoMessage === ''">
        <input name="email" type="email" :placeholder="$t('ForgotPassword.email')" v-model="email">
      </form>
      <div class="info-message" v-if="infoMessage !== ''">{{ infoMessage }}</div>
      <div class="alert-message" v-if="alertMessage !== ''">{{ alertMessage }}</div>
      <button class="submit-btn" @click="submit" v-if="infoMessage === ''" :disabled="isLoading">{{ $t('ForgotPassword.submit') }}</button>
      <div class="goto-login" @click="clickGotoLogin" :disabled="isLoading">{{ $t('ForgotPassword.login') }}</div>
    </div>
    <div v-if="isLoading" class="loading-animation-container">
      <div class="loading-animation primary"></div>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'

export default {
  name: 'ForgotPassword',
  components: {
    TitleBar
  },
  data () {
    return {
      email: '',
      infoMessage: '',
      alertMessage: '',
      isLoading: false
    }
  },
  methods: {
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    clickGotoLogin () {
      var self = this
      self.$root.$emit('openModal', {
        name: 'Login'
      })
    },
    submit () {
      var self = this
      self.isLoading = true
      self.infoMessage = ''
      self.alertMessage = ''
      self.pp.forgotPassword(
        self.$root.$i18n.locale,
        self.email,
        new Date().getTime(),
        (result) => {
          if (result.status.code === 200) {
            self.infoMessage = result.status.text
          } else if (result.status.code === 403) {
            self.alertMessage = result.status.text
          } else {
            self.alertMessage = result.status.text
          }
          self.isLoading = false
        }
      )
    }
  }
}
</script>

<style scoped>
  .forgot-password {
    height: fit-content;
    width: 320px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .body {
    padding: 16px;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }

  input[type="email"] {
    width: 100%;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(120, 120, 120);
    border-radius: 4px;
    margin: 0px 0px 8px 0px;
    padding: 10px;
    line-height: 1.75;
    color: rgb(74, 74, 74);
    box-sizing: border-box;
    height: 40px;
  }

  ::-webkit-input-placeholder {
    line-height: 1.75;
    color: rgb(120, 120, 120);
  }

  .submit-btn {
    width: 100%;
    padding: 6px;
    background: rgb(59, 144, 255);
    border-radius: 4px;
    border: none;
    color: rgb(255, 255, 255);
    margin: 8px 0px 8px 0px;
    cursor: pointer;
  }

  .goto-login {
    border-radius: 4px;
    color: rgb(59, 144, 255);
    border: 1px solid rgb(59, 144, 255);
    margin: 8px auto 0px auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 4px;
    width: 100%;
    box-sizing: border-box;
  }

  .loading-animation-container {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.6);
  }

  .info-message {
    text-align: left;
    color: rgb(59, 144, 255);
  }

  .alert-message {
    text-align: left;
    color: rgb(220, 20, 60);
  }
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue